import React, { Component } from 'react'
import AuthenticationService from '../general/AuthenticationService.js'
import ElementsDataService from '../../api/entitiesDataServices/ElementsDataService.js'

const T = {
    bg:'#f1f5f9', card:'#ffffff', border:'#e8edf5',
    blue:'#3b82f6', blueD:'#2563eb', navy:'#0f172a',
    txt:'#1e293b', txt2:'#64748b', muted:'#94a3b8',
    green:'#16a34a', greenBg:'#f0fdf4', greenBdr:'#bbf7d0',
    red:'#dc2626', redBg:'#fef2f2', redBdr:'#fecaca',
    r:16, rsm:10,
    shadow:'0 1px 3px rgba(15,23,42,.06)',
    font:"'Inter',-apple-system,BlinkMacSystemFont,'Segoe UI',sans-serif",
}

class UsersComponent extends Component {
    constructor(props) {
        super(props)
        this.state = {
            ...props,
            elements: [],
            loading: true,
            confirm: null,      // { message, onConfirm }
            toggling: null,     // userName en proceso de toggle
            forceingOut: null,  // userName en proceso de force-logout
            search: '',
            cloneSource: null,  // userName a clonar
        }
        this.toggleUserEnabled  = this.toggleUserEnabled.bind(this)
        this.forceLogout        = this.forceLogout.bind(this)
    }

    componentDidMount() {
        if (!AuthenticationService.haveAuthorization('READ_USUARIOS')) {
            this.props.history.push('/login')
            return
        }
        this.props.refreshElements()
    }

    toggleUserEnabled(userName, currentEnabled) {
        const action = currentEnabled ? 'desactivar' : 'activar'
        this.setState({
            confirm: {
                message: `¿Deseas ${action} al usuario "${userName}"?`,
                onConfirm: () => {
                    this.setState({ confirm: null, toggling: userName })
                    ElementsDataService.updateElement('users', `${userName}/toggle`, {})
                        .then(() => this.props.refreshElements())
                        .finally(() => this.setState({ toggling: null }))
                }
            }
        })
    }

    forceLogout(userName) {
        this.setState({
            confirm: {
                message: `¿Forzar cierre de sesión de "${userName}"? Su sesión activa será invalidada inmediatamente.`,
                onConfirm: () => {
                    this.setState({ confirm: null, forceingOut: userName })
                    ElementsDataService.updateElement('users', `${userName}/force-logout`, {})
                        .then(() => this.props.refreshElements())
                        .finally(() => this.setState({ forceingOut: null }))
                }
            }
        })
    }

    render() {
        let counter = 0
        const elements = this.props.elements || []
        const { loading, confirm, toggling, forceingOut, search, cloneSource } = this.state

        const filtered      = elements.filter(e =>
            !search || e.userName.toLowerCase().includes(search.toLowerCase()))
        const activeCount   = elements.filter(e => e.enabled).length
        const inactiveCount = elements.filter(e => !e.enabled).length

        const thS = { padding:'10px 16px', fontSize:11, fontWeight:700, color:T.txt2,
            textTransform:'uppercase', letterSpacing:'.05em', borderBottom:`2px solid ${T.border}`,
            background:'#f8fafc', textAlign:'left' }
        const tdS = { padding:'13px 16px', borderBottom:`1px solid ${T.border}`, verticalAlign:'middle' }

        return (
            <div style={{ minHeight:'100vh', background:T.bg, fontFamily:T.font, padding:'24px 28px 64px' }}>
                <style>{`
                    @import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700&display=swap');
                    @keyframes spin { to { transform:rotate(360deg) } }
                    tr:hover td { background: #eff6ff !important; }
                `}</style>

                {/* ── Modal confirmación ── */}
                {confirm && (
                    <div style={{ position:'fixed', inset:0, zIndex:1000, display:'flex',
                        alignItems:'center', justifyContent:'center',
                        background:'rgba(15,23,42,.45)', backdropFilter:'blur(4px)' }}>
                        <div style={{ background:T.card, borderRadius:T.r, padding:'28px 32px',
                            maxWidth:400, width:'90%', boxShadow:'0 20px 60px rgba(15,23,42,.2)', fontFamily:T.font }}>
                            <div style={{ fontSize:32, textAlign:'center', marginBottom:12 }}>⚠️</div>
                            <p style={{ margin:'0 0 24px', fontSize:15, color:T.txt, textAlign:'center', lineHeight:1.5 }}>
                                {confirm.message}
                            </p>
                            <div style={{ display:'flex', gap:10, justifyContent:'center' }}>
                                <button onClick={() => this.setState({ confirm: null })}
                                    style={{ padding:'9px 22px', borderRadius:T.rsm, border:`1px solid ${T.border}`,
                                        background:T.bg, color:T.txt2, fontSize:13, fontWeight:600,
                                        cursor:'pointer', fontFamily:T.font }}>
                                    Cancelar
                                </button>
                                <button onClick={confirm.onConfirm}
                                    style={{ padding:'9px 22px', borderRadius:T.rsm, border:'none',
                                        background:T.red, color:'white', fontSize:13, fontWeight:700,
                                        cursor:'pointer', fontFamily:T.font,
                                        boxShadow:`0 4px 12px ${T.red}40` }}>
                                    Confirmar
                                </button>
                            </div>
                        </div>
                    </div>
                )}

                <div style={{ maxWidth:860, margin:'0 auto' }}>

                    {/* ── Header ── */}
                    <div style={{ display:'flex', alignItems:'center', justifyContent:'space-between',
                        marginBottom:20, flexWrap:'wrap', gap:12 }}>
                        <div>
                            <h1 style={{ margin:0, fontSize:22, fontWeight:800, color:T.navy, letterSpacing:'-0.025em' }}>
                                Usuarios
                            </h1>
                            <p style={{ margin:'3px 0 0', fontSize:13, color:T.txt2 }}>
                                {elements.length} usuario{elements.length !== 1 ? 's' : ''} registrado{elements.length !== 1 ? 's' : ''}
                            </p>
                        </div>
                        <div style={{ display:'flex', gap:8, alignItems:'center' }}>
                            {/* Search */}
                            <div style={{ position:'relative' }}>
                                <input
                                    value={search}
                                    onChange={e => this.setState({ search: e.target.value })}
                                    placeholder="Buscar usuario..."
                                    style={{ padding:'9px 14px 9px 36px', borderRadius:T.rsm,
                                        border:`1px solid ${T.border}`, fontSize:13, color:T.txt,
                                        background:T.card, outline:'none', width:200, fontFamily:T.font }}
                                />
                                <span style={{ position:'absolute', left:11, top:'50%',
                                    transform:'translateY(-50%)', color:T.muted, fontSize:14 }}>🔍</span>
                            </div>
                            <button onClick={this.props.addElementClicked}
                                style={{ display:'inline-flex', alignItems:'center', gap:8, padding:'9px 18px',
                                    borderRadius:T.rsm, border:'none', background:T.blue, color:'white',
                                    fontSize:13, fontWeight:700, cursor:'pointer', fontFamily:T.font,
                                    boxShadow:`0 4px 12px ${T.blue}40` }}>
                                ＋ Nuevo Usuario
                            </button>
                        </div>
                    </div>

                    {/* ── Stats ── */}
                    {!loading && elements.length > 0 && (
                        <div style={{ display:'flex', gap:10, marginBottom:16 }}>
                            {[
                                { label:'Total',     value:elements.length, color:T.blue,  bg:`${T.blue}12`, bdr:`${T.blue}20` },
                                { label:'Activos',   value:activeCount,     color:T.green, bg:T.greenBg,     bdr:T.greenBdr },
                                { label:'Inactivos', value:inactiveCount,   color:T.red,   bg:T.redBg,       bdr:T.redBdr },
                            ].map(s => (
                                <div key={s.label} style={{ flex:1, background:T.card, border:`1px solid ${T.border}`,
                                    borderRadius:T.rsm, padding:'12px 16px', boxShadow:T.shadow }}>
                                    <div style={{ fontSize:20, fontWeight:800, color:s.color }}>{s.value}</div>
                                    <div style={{ fontSize:12, color:T.txt2, marginTop:2 }}>{s.label}</div>
                                </div>
                            ))}
                        </div>
                    )}

                    {/* ── Tabla ── */}
                    <div style={{ background:T.card, border:`1px solid ${T.border}`, borderRadius:T.r,
                        boxShadow:T.shadow, overflow:'hidden' }}>

                        {loading ? (
                            <div style={{ padding:'60px 24px', textAlign:'center' }}>
                                <div style={{ width:36, height:36, border:`3px solid ${T.border}`, borderTopColor:T.blue,
                                    borderRadius:'50%', animation:'spin .7s linear infinite', margin:'0 auto 12px' }} />
                                <p style={{ margin:0, fontSize:14, color:T.muted }}>Cargando usuarios...</p>
                            </div>
                        ) : elements.length === 0 ? (
                            <div style={{ padding:'60px 24px', textAlign:'center' }}>
                                <div style={{ fontSize:36, marginBottom:10 }}>👤</div>
                                <p style={{ margin:0, fontSize:14, fontWeight:600, color:T.txt }}>Sin usuarios registrados</p>
                                <p style={{ margin:'4px 0 0', fontSize:13, color:T.muted }}>Crea el primero con el botón de arriba</p>
                            </div>
                        ) : (
                            <table style={{ width:'100%', borderCollapse:'collapse' }}>
                                <thead>
                                    <tr>
                                        <th style={{ ...thS, width:40 }}>#</th>
                                        <th style={thS}>Usuario</th>
                                        <th style={thS}>Estado</th>
                                        <th style={thS}>Último ingreso</th>
                                        <th style={{ ...thS, textAlign:'right' }}>Acciones</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {filtered.length === 0 && (
                                        <tr><td colSpan={5} style={{ padding:'32px', textAlign:'center', color:T.muted, fontSize:13 }}>
                                            Sin resultados para "{search}"
                                        </td></tr>
                                    )}
                                    {filtered.map((el, i) => {
                                        const isToggling   = toggling === el.userName
                                        const isForcingOut = forceingOut === el.userName
                                        const isCloneSource = cloneSource === el.userName
                                        return (
                                            <tr key={el.userName} style={{ opacity: !el.enabled ? 0.55 : 1 }}>
                                                <td style={{ ...tdS, background:i%2===0?T.card:T.bg,
                                                    fontSize:12, color:T.muted, fontWeight:700, textAlign:'center' }}>
                                                    {++counter}
                                                </td>
                                                <td style={{ ...tdS, background:i%2===0?T.card:T.bg }}>
                                                    <div style={{ display:'flex', alignItems:'center', gap:12 }}>
                                                        <div style={{ width:34, height:34, borderRadius:'50%',
                                                            background: el.enabled ? T.blue : T.muted,
                                                            display:'flex', alignItems:'center', justifyContent:'center',
                                                            color:'white', fontWeight:700, fontSize:13, flexShrink:0 }}>
                                                            {(el.userName || '?')[0].toUpperCase()}
                                                        </div>
                                                        <span style={{ fontSize:14, fontWeight:600, color:T.txt }}>
                                                            {el.userName}
                                                        </span>
                                                    </div>
                                                </td>
                                                <td style={{ ...tdS, background:i%2===0?T.card:T.bg }}>
                                                    <span style={{ display:'inline-flex', alignItems:'center', gap:6,
                                                        padding:'3px 12px', borderRadius:20, fontSize:12, fontWeight:600,
                                                        background: el.enabled ? T.greenBg : T.redBg,
                                                        color:       el.enabled ? T.green   : T.red,
                                                        border:`1px solid ${el.enabled ? T.greenBdr : T.redBdr}` }}>
                                                        <span style={{ width:7, height:7, borderRadius:'50%',
                                                            background: el.enabled ? T.green : T.red }} />
                                                        {el.enabled ? 'Activo' : 'Inactivo'}
                                                    </span>
                                                </td>
                                                {/* Último ingreso */}
                                                <td style={{ ...tdS, background:i%2===0?T.card:T.bg }}>
                                                    {el.lastLogin ? (
                                                        <div style={{ display:'flex', flexDirection:'column', gap:5 }}>
                                                            <div style={{ fontSize:12, fontWeight:600, color:T.txt, lineHeight:'1' }}>
                                                                {new Date(el.lastLogin).toLocaleDateString('es-MX', { day:'2-digit', month:'short', year:'numeric' })}
                                                            </div>
                                                            <div style={{ fontSize:11, color:T.muted, lineHeight:'1' }}>
                                                                {new Date(el.lastLogin).toLocaleTimeString('es-MX', { hour:'2-digit', minute:'2-digit' })}
                                                            </div>
                                                        </div>
                                                    ) : (
                                                        <span style={{ fontSize:12, color:T.muted }}>Sin registros</span>
                                                    )}
                                                </td>
                                                {/* Acciones */}
                                                <td style={{ ...tdS, background:i%2===0?T.card:T.bg }}>
                                                    <div style={{ display:'flex', gap:6, justifyContent:'flex-end' }}>
                                                        {/* Editar */}
                                                        <button title="Editar"
                                                            onClick={() => this.props.updateElementClicked(el.userName)}
                                                            style={{ width:32, height:32, borderRadius:8, border:'none',
                                                                background:`${T.blue}15`, color:T.blueD, cursor:'pointer',
                                                                fontSize:14, display:'flex', alignItems:'center',
                                                                justifyContent:'center', transition:'all .15s' }}
                                                            onMouseEnter={e => { e.currentTarget.style.background=T.blue; e.currentTarget.style.color='white' }}
                                                            onMouseLeave={e => { e.currentTarget.style.background=`${T.blue}15`; e.currentTarget.style.color=T.blueD }}>
                                                            ✏️
                                                        </button>
                                                        {/* Clonar */}
                                                        <button title="Clonar permisos a nuevo usuario"
                                                            onClick={() => {
                                                                this.setState({ cloneSource: isCloneSource ? null : el.userName })
                                                                if (!isCloneSource) {
                                                                    // Pre-fill authorities and navigate to new user form
                                                                    this.props.history.push(`/users/-1?clone=${el.userName}`)
                                                                }
                                                            }}
                                                            style={{ width:32, height:32, borderRadius:8, border:'none',
                                                                background:'#f0fdf4', color:T.green, cursor:'pointer',
                                                                fontSize:14, display:'flex', alignItems:'center',
                                                                justifyContent:'center', transition:'all .15s' }}
                                                            onMouseEnter={e => { e.currentTarget.style.background=T.green; e.currentTarget.style.color='white' }}
                                                            onMouseLeave={e => { e.currentTarget.style.background='#f0fdf4'; e.currentTarget.style.color=T.green }}>
                                                            ⧉
                                                        </button>
                                                        {/* Force logout */}
                                                        <button title="Forzar cierre de sesión"
                                                            onClick={() => this.forceLogout(el.userName)}
                                                            disabled={isForcingOut}
                                                            style={{ width:32, height:32, borderRadius:8, border:'none',
                                                                background:'#fff7ed', color:'#c2410c',
                                                                cursor: isForcingOut ? 'not-allowed' : 'pointer',
                                                                fontSize:14, display:'flex', alignItems:'center',
                                                                justifyContent:'center', transition:'all .15s' }}
                                                            onMouseEnter={e => { if (!isForcingOut) { e.currentTarget.style.background='#c2410c'; e.currentTarget.style.color='white' }}}
                                                            onMouseLeave={e => { e.currentTarget.style.background='#fff7ed'; e.currentTarget.style.color='#c2410c' }}>
                                                            {isForcingOut
                                                                ? <div style={{ width:12, height:12, border:'2px solid currentColor',
                                                                    borderTopColor:'transparent', borderRadius:'50%',
                                                                    animation:'spin .7s linear infinite' }} />
                                                                : '⏏'}
                                                        </button>
                                                        {/* Toggle activo/inactivo */}
                                                        <button title={el.enabled ? 'Desactivar' : 'Activar'}
                                                            onClick={() => this.toggleUserEnabled(el.userName, el.enabled)}
                                                            disabled={isToggling}
                                                            style={{ width:32, height:32, borderRadius:8, border:'none',
                                                                background: el.enabled ? `${T.red}15` : `${T.green}15`,
                                                                color: el.enabled ? T.red : T.green,
                                                                cursor: isToggling ? 'not-allowed' : 'pointer',
                                                                fontSize:14, display:'flex', alignItems:'center',
                                                                justifyContent:'center', transition:'all .15s' }}
                                                            onMouseEnter={e => { if (!isToggling) { e.currentTarget.style.background = el.enabled ? T.red : T.green; e.currentTarget.style.color='white' }}}
                                                            onMouseLeave={e => { e.currentTarget.style.background = el.enabled ? `${T.red}15` : `${T.green}15`; e.currentTarget.style.color = el.enabled ? T.red : T.green }}>
                                                            {isToggling
                                                                ? <div style={{ width:12, height:12, border:'2px solid currentColor',
                                                                    borderTopColor:'transparent', borderRadius:'50%',
                                                                    animation:'spin .7s linear infinite' }} />
                                                                : el.enabled ? '🚫' : '✅'
                                                            }
                                                        </button>
                                                        {/* Eliminar */}
                                                        <button title="Eliminar permanentemente"
                                                            onClick={() => this.setState({
                                                                confirm: {
                                                                    message: `⚠️ Esto eliminará permanentemente al usuario "${el.userName}" y todo su historial de actividad. Esta acción no se puede deshacer.`,
                                                                    onConfirm: () => {
                                                                        this.setState({ confirm: null })
                                                                        ElementsDataService.deleteElement('users', el.userName)
                                                                            .then(() => this.props.refreshElements())
                                                                    }
                                                                }
                                                            })}
                                                            style={{ width:32, height:32, borderRadius:8, border:'none',
                                                                background:'#fff3e0', color:'#e65100', cursor:'pointer',
                                                                fontSize:14, display:'flex', alignItems:'center',
                                                                justifyContent:'center', transition:'all .15s' }}
                                                            onMouseEnter={e => { e.currentTarget.style.background='#e65100'; e.currentTarget.style.color='white' }}
                                                            onMouseLeave={e => { e.currentTarget.style.background='#fff3e0'; e.currentTarget.style.color='#e65100' }}>
                                                            🗑️
                                                        </button>
                                                    </div>
                                                </td>
                                            </tr>
                                        )
                                    })}
                                </tbody>
                            </table>
                        )}
                    </div>
                </div>
            </div>
        )
    }
}

export default UsersComponent
